<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <div class=" pb-4">
                <v-btn @click="redirectByUrl('/admin/services')" outlined style="border: none;background: #fff" title="Retourner">
                <v-icon>mdi mdi-arrow-left</v-icon>
                Les services
                </v-btn>
            </div>
            <v-card>
                <div class="row">
                    <h6 class="col-12">{{$t('intram_service.service_parameter_title')}} {{ service ? service._name : '...' }}</h6>
                    <div class="col-lg-4 col-12">
                    <v-text-field v-model="search" append-icon="mdi-magnify" solo label="Search" single-line  hide-details></v-text-field>
                    </div>
                    <div class="col-lg-8 col-12 text-right">
                        <v-btn color="default" dark class="mb-2" @click="dialog=true">{{$t('intram_service.add_service_parameter')}}</v-btn>
                    </div>  
                </div>
                <v-data-table no-headers
                        :headers="headers"
                        :items="options_datas"
                        :search="search"
                        :loading="options_datas===undefined || options_status" loading-text="Chargement en cours..."
                        sort-by="label"
                        class="elevation-0 mt-0 pt-0">
                    <template v-slot:item._created_at="{item}">
                        {{ new Date(item._created_at).toLocaleDateString()}}
                    </template>
                     <template v-slot:item._description="{item}">
                        {{ limiText(item._description,50) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                     <v-list-item  @click="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6"> mdi-pencil
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title >
                                               Modifier
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item  @click="confimDeleteServices(item)">
                                        <v-list-item-icon>
                                            <v-icon color="red"> mdi-trash-can-outline
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title >
                                               Supprimer
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    
                                </v-list>
                            </v-menu>
                        </div>

                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
                  <div class="col-12 text-right" style="background : #f8f8f8">
                        <v-pagination
                        elevation="0"
                        v-model="page"
                        :length="total_pages"
                        :total-visible="7"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right"
                        @input="getAllServices"
                        ></v-pagination>
                    <!-- product pagination -->
                </div>

                 <v-dialog v-model="dialog" max-width="500px">
                                <v-card>
                                    <v-card-text>
                                        <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>
                                        <v-alert v-if="errors.operation" dense outlined type="error">
                                            {{errors.operation}}
                                        </v-alert>
                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                                            <v-row>
                                                <v-col cols="12" sm="12" class="mt-5">
                                                    <h3>Paramètre du service {{ service ? service._name : '...' }}</h3>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <label>Nom du paramètre</label>
                                                    <v-text-field solo :rules="inputRules" v-model="editedItem._name" :label="$t('name')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                     <label>Slug</label>
                                                    <v-text-field type="text" solo :rules="inputRules" v-model="editedItem._slug" :label="$t('slug')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" >
                                                     <label>Valeur</label>
                                                    <v-text-field type="text" solo :rules="inputRules" v-model="editedItem._value" :label="$t('value')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" >
                                                    <label>Description</label>
                                                    <v-textarea solo
                                                            :rules="descriptionRules"
                                                            v-model="editedItem._description"
                                                            name="input-7-4"
                                                            rows="2"
                                                            :label="$t('description')"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click.prevent="close">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary" :loading="submitting" :disabled="!valid || mis"  @click.prevent="save">{{id ? $t("update") : $t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

            </v-card>
        </div>
    </div>
</template>


<script>
    import * as Swal from "sweetalert2";
    import helpers from "../../../mixins/helpers";
    import {client} from "../../../store/services/client";
    import {env} from "../../../../env";
    export default {
        name: "services",
        mixins:[helpers(this)],
        data () {
            return {
                service:undefined,
                page: 0,
                total_pages: 0,
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                errors:{},
                files: [],
                search: '',
                dialog: '',
                items: ['Api', 'Manual'],
                options_datas:undefined,
                options_status:false,
                gateway_base_link: env.gateway,
                image_base_link: env.image_base_url,
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                id:undefined,
                headers: [
                    {
                        text: this.$t('name'),
                        align: 'start',
                        sortable: false,
                        value: '_name',
                    },

                    {text: this.$t('slug'), value: '_slug'},
                    {text: this.$t('valeur'), value: '_value'},
                    {text: this.$t('description'), value: '_description'},
                    {text: this.$t('date'), value: '_created_at'},
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _name: '',
                    _slug: '',
                    _value: '',
                    _description: '',
                    _created_at: new Date(),
                    _id:''
                },
                defaultItem: {
                    _name: '',
                    _slug: '',
                    _value: '',
                    _description: '',
                    _created_at: new Date(),
                    _id:''
                },
                labelRules: [
                    v => !!v ||  this.$t('name_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                inputRules: [
                    v => !!v ||  this.$t('value_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                descriptionRules: [
                    v => !!v || this.$t('description_required'),
                ],
                codeRules: [
                    v => !!v ||  this.$t('code_required'),
                ],
                fileRules: [
                    v => !!v ||  this.$t('file_required'),
                ],
            }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.getAllServices();
            },
            editItem (item) {
               this.editedIndex = this.options_datas.indexOf(item)
                this.editedItem = item
                this.dialog = true
                this.id = item._id;
            },

            description (item) {
                Swal.fire({
                    title: this.$t('description'),
                    timerProgressBar: false,
                    text: item._description,
                    confirmButtonText: "Fermer",
                    confirmButtonColor:'#29B3A6',
                })
            },


            close () {
                this.dialog = false;
                this.$nextTick(() => {
                   // this.editedItem = Object.assign({}, this.defaultItem)
                    //this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            async confimDeleteServices(item) {
                this.confirm_toast(
                        'warning',
                        'Suppression',
                        "Êtes vous sûr de vouloir éffectuer cette action ?",
                        'Oui, supprimer',
                        "Non",
                   await this.deleteServices(item)
                )
            },
            async deleteServices(item) {
                this.service_status = true
                const response = await client({
                    method: 'post',
                    url: `/services/parameters/delete`,
                    data: {id:item._id}
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        this.service_status = false
                        return {
                        error: true
                        }
                    })
                this.service_status = false
                if (response && !response.error)
                    this.getAllServices();
            },
            async getAllServices(page=1) {
                this.service_status = true
                page=page-1;
                const response = await client({
                    method: 'post',
                    url: `/services/parameters`,
                    data: {page:page, "service":this.$route.params.service_slug}
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        this.service_status = false
                        return {
                        error: true
                        }
                    })
                this.service_status = false
                if (response && !response.error)
                    this.options_datas = response.services
                    this.service = response.service
                    this.page=response.page+1;
                    this.total_pages = response.total_pages
            },
            async save () {
                let VueBox = this;
                this.editedItem._service=this.$route.params.service_slug;
                let url='/services/parameters/created'
                if (this.id){
                    this.editedItem._id=this.id;
                }
                this.submitting = true;
                const response = await client({
                    method: 'post',
                    url: url,
                    data: this.editedItem
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        this.submitting = false
                        return {
                        error: true
                        }
                    })
                this.submitting = false
                if (response && !response.error)
                    VueBox.toast('success',this.$t(response.message))
                    VueBox.reset()
                    VueBox.dialog=false
                    VueBox.id = undefined
                    VueBox.getAllServices();
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

</style>
